
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(6(314|633|722)|15(33|6|98)|7(022|076|747)|3(570|597|8)|4121|5094|8561|928)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
